module.exports = __webpack_public_path__ + "static/media/compose.cafcff61.png";